export default "__VITE_PUBLIC_ASSET__56a40f3c__"